import { render, staticRenderFns } from "./MealManagement2.vue?vue&type=template&id=0a376b87&scoped=true&"
import script from "./MealManagement2.vue?vue&type=script&lang=js&"
export * from "./MealManagement2.vue?vue&type=script&lang=js&"
import style0 from "./MealManagement2.vue?vue&type=style&index=0&id=0a376b87&scoped=true&lang=css&"
import style1 from "./MealManagement2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a376b87",
  null
  
)

export default component.exports